__turbopack_context__.v({
  "container": "select-module__gwCrpW__container",
  "group": "select-module__gwCrpW__group",
  "group-header": "select-module__gwCrpW__group-header",
  "has-focus": "select-module__gwCrpW__has-focus",
  "input": "select-module__gwCrpW__input",
  "is-selected": "select-module__gwCrpW__is-selected",
  "option": "select-module__gwCrpW__option",
  "options": "select-module__gwCrpW__options",
  "row": "select-module__gwCrpW__row",
  "search_container": "select-module__gwCrpW__search_container",
  "select": "select-module__gwCrpW__select",
});
